import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AiUsageCompanyLimitModel, ArkUserType, ClientModel } from '../../core/api/models';
import { AiUsageApiService } from '../../core/api/services';
import { Utils } from '../../core/utils';
import { AuthService } from '../../main/auth.service';
import { ClientService } from '../';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-client-ai-usage',
  templateUrl: './client-ai-usage.component.html',
  standalone: false
})
export class ClientAIUsageComponent implements OnInit {
  currentClient?: ClientModel;
  currentItem?: AiUsageCompanyLimitModel;
  loading = true;
  readonly aiModelPricingLink = ['/ai-model-pricing'];

  constructor(
    private authService: AuthService,
    private readonly clientService: ClientService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private apiService: AiUsageApiService) {
  }

  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);


    this.clientService.getCurrentClient().subscribe((client) => {

      if (client){
         this.currentClient = client;
          

          
        this.load(client.ID||0);
    }
    });


  }

  save(): void {
    if (!this.currentItem)
      return;

    this.loading = true;
    this.apiService.SaveCompanyLimit({ body: this.currentItem }).subscribe({
      next: saved => {
        this.currentItem = saved;
        this.loading = false;
        this.alertService.success('AI usage company limits saved successfully');
      },
      error: err => {
        this.loading = false;
        this.alertService.error(Utils.getAjaxError(err));
      }
    });
  }

  private load(clientID: number): void {
    this.loading = true;
    this.apiService.GetCompanyLimit({ clientID }).subscribe({
      next: item => {
        this.currentItem = item;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.alertService.error(Utils.getAjaxError(err));
      }
    });
  }
}
